export const externalLinkProps = {
  target: '_blank',
  rel: 'noreferrer',
}
